<template>
  <div class="result-component result-component-breakdown">
    <div class="result-heading">
      <h2>{{ config.title }}</h2>
    </div>
    <ul class='breakdown'>
      <li :key='item.score' v-for='item in breakdown'>
        Percentile: {{ item.percentile }} -  Count: {{ item.count}} - {{ getScoreBand(item.percentile*100, bands)}}
      </li>
    </ul>
    <div class="comp-type">
      <slot name='comptype'></slot>
    </div>
  </div>
</template>
<script>
import ConvinceStub from '@/lib/ConvinceStub'
import Scoring from '../lib/Scoring.js'
const convince = window.convince || new ConvinceStub(window.convinceConfig)
export default {
  props: ['config', 'score', 'bands'],
  mixins: [Scoring],
  data () {
    return {
      breakdown: []
    }
  },
  created () {
    // this.getBreakdown(this.config.key, function (data) { this.breakdown = data }.bind(this))
    convince.breakdown(this.config.key).then(function (res) {
      this.breakdown = res.data
    }.bind(this))
  }
}
</script>
<style lang='scss'>
  ul {
    list-style-type:none;
  }
</style>
